import React, { useCallback, useMemo } from "react";
import { FilterMetadataApiWithCountReturn, PROVIDER_CONNECTION_TYPE, WaterProvider } from "../misc";
import { Map } from "./Map";
import styles from "./Map.module.scss";
import { SpatialValue } from "./types";
import { event as mapClickEvent } from "../GA/ProviderInfo/MapClick";
import { useLocation } from "react-router-dom";

interface ProviderInfoMapProps {
    metadata?: FilterMetadataApiWithCountReturn;
    provider?: WaterProvider;
    className?: string;
    allowOnClick?: boolean;
    onFeatureClick?: (args: { code: string; feature: Record<string, unknown> }) => void;
}
export const ProviderInfoMap: React.FC<ProviderInfoMapProps> = ({
    metadata,
    provider,
    allowOnClick,
    className,
    onFeatureClick
}) => {
    // const highlightedAdminIds = useMemo(() => {
    //     return [provider?.adminId].filter(d => d != null && d.trim() !== "");
    // }, [provider?.adminId]);

    const { pathname } = useLocation();
    const useHighlightEffect = useMemo(() => {
        return provider?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk ? false : true;
    }, [provider]);

    const onPostFeatureClick: (args: {
        code: string;
        feature: Record<string, unknown>;
        data: SpatialValue;
        value: string;
    }) => void = useCallback(
        ({ data }) => {
            if (data?.name != null) mapClickEvent(pathname, data?.name);
        },
        [pathname]
    );

    return (
        <div className={`col fix-width-col-515 map-provider-profile ${className ?? ""}`}>
            <div className={styles.mapContainer}>
                <div className={styles.mapWrapper}>
                    <Map
                        providerName={provider?.name}
                        providerMapName={provider?.systemName}
                        metadata={metadata}
                        adminId={provider?.adminId}
                        useHighlightEffectForSelection={useHighlightEffect}
                        oceanLayerDisplay={false}
                        // highlightedProviderAdminIds={highlightedAdminIds}
                        allowOnClick={allowOnClick}
                        onFeatureClick={onFeatureClick}
                        onPostFeatureClick={onPostFeatureClick}
                    />
                </div>
            </div>
        </div>
    );
};
